<span class="w-full p-input-icon-right">
  <label class="block mb-1 text-color-secondary" [iosRequired]="isRequired">{{ label | translate }}</label>
  <p-password
    [formControl]="password"
    [toggleMask]="true"
    styleClass="p-password p-component p-inputwrapper p-input-icon-right"
    strongRegex="(?=^.{8,}$)(?=.*\d)(?=.*[!&quot;#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~])(?=.*[A-Z])(?=.*[a-z]).{8,}$"
    class="ios-password"
    [class.ng-invalid]="isInvalid"
    [class.ng-dirty]="isInvalid"
    [promptLabel]="passwordHelpers['enterPassword']"
    [weakLabel]="passwordHelpers['weak']"
    [mediumLabel]="passwordHelpers['medium']"
    [strongLabel]="passwordHelpers['strong']"
    (onFocus)="onTouched()"
  >
    <ng-template pTemplate="footer">
      <p-divider></p-divider>
      <p class="p-mt-2">{{ passwordHelpers['suggestion'] }}</p>
      <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
        <li>{{ passwordHelpers['lowerCase'] }}</li>
        <li>{{ passwordHelpers['upperCase'] }}</li>
        <li>{{ passwordHelpers['numeric'] }}</li>
        <li>{{ passwordHelpers['symbol'] }}</li>
        <li>{{ passwordHelpers['minLength'] }}</li>
        <li>{{ passwordHelpers['maxLength'] }}</li>
      </ul>
    </ng-template>
  </p-password>
</span>
